var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83301 8.5V12C8.83301 12.2023 8.95481 12.3845 9.14167 12.4619C9.32847 12.5393 9.54354 12.4966 9.68654 12.3536L13.6865 8.3536C13.7803 8.2598 13.833 8.1326 13.833 8C13.833 7.8674 13.7803 7.7402 13.6865 7.64647L9.68654 3.64646C9.54354 3.50346 9.32847 3.46069 9.14167 3.53807C8.95481 3.61547 8.83301 3.79779 8.83301 4.00001V7.5V8.5Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.840beafee51755b6fe271c3b32410165.svg";
export { ForwardRef as ReactComponent };